import { createReducer } from 'redux-act';
import { IComment, IDeleteCommentAction, IDictionary } from '../../types';
import {
  changeCommentsState,
  deleteCommentSuccess,
  fetchCommentCountsSuccess,
  fetchImageCommentsSuccess
} from '../../actions';
import { IFetchImageCommentsSuccessAction } from '../../types/comments';

export interface ICommentsState {
  // imageId -> number of comments, one cheap fetch per collection drives the grid badges
  countsByImageId: IDictionary<number>;
  // imageId -> full thread, filled when the viewer modal opens
  threads: IDictionary<IComment[]>;
  isFetching: boolean;
  deletingId: string | null;
}

const initialState: ICommentsState = {
  countsByImageId: {},
  threads: {},
  isFetching: false,
  deletingId: null
};

export const comments = createReducer<ICommentsState>({}, initialState);

comments.on(fetchCommentCountsSuccess, (state: ICommentsState, payload: IDictionary<number>) => ({
  ...state,
  countsByImageId: payload
}));

comments.on(
  fetchImageCommentsSuccess,
  (state: ICommentsState, { imageId, comments: thread }: IFetchImageCommentsSuccessAction) => ({
    ...state,
    isFetching: false,
    threads: { ...state.threads, [imageId]: thread },
    countsByImageId: { ...state.countsByImageId, [imageId]: thread.length }
  })
);

comments.on(
  deleteCommentSuccess,
  (state: ICommentsState, { commentId, imageId }: IDeleteCommentAction) => {
    const thread = (state.threads[imageId] || []).filter((comment) => comment._id !== commentId);

    return {
      ...state,
      deletingId: null,
      threads: { ...state.threads, [imageId]: thread },
      countsByImageId: { ...state.countsByImageId, [imageId]: thread.length }
    };
  }
);

comments.on(changeCommentsState, (state: ICommentsState, payload: Partial<ICommentsState>) => ({
  ...state,
  ...payload
}));
